var exports = {
  "label": "x1cb7f6e3--96ec8b--label",
  "red": "x1cb7f6e3--96ec8b--red",
  "green": "x1cb7f6e3--96ec8b--green",
};

module.exports = exports;
